import { PlatformLocation } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { MASKS } from 'ng-brazil';
import { BehaviorSubject, Subscription } from 'rxjs';
import { CRMCanalVenda } from 'src/app/models/crm/crmcanal-venda';
import { CRMContato } from 'src/app/models/crm/crmcontato';
import { CRMHierarquiaUsuario } from 'src/app/models/crmhierarquia-usuario';
import { CRMOportunidade } from 'src/app/models/crm/crmoportunidade';
import { CRMOportunidadeAtributo } from 'src/app/models/crm/crmoportunidade-atributo';
import { CRMTag } from 'src/app/models/crm/crmtag';
import { CRMAtributoMascara, StatusCadastroEnum } from 'src/app/models/enum';
import { Ibge } from 'src/app/models/ibge';
import { CarregandoService } from 'src/app/services/carregando.service';
import { CrmService } from 'src/app/services/crm/crm.service';
import { CrmcanalVendaService } from 'src/app/services/crm/crmcanal-venda.service';
import { CrmcontatoService } from 'src/app/services/crm/crmcontato.service';
import { CrmoportunidadeService } from 'src/app/services/crm/crmoportunidade.service';
import { CrmtagService } from 'src/app/services/crm/crmtag.service';
import { CrmtipoAtividadeService } from 'src/app/services/crm/crmtipo-atividade.service';
import { GlobalService } from 'src/app/services/global.service';
import { IbgeService } from 'src/app/services/ibge.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { ViaCepService } from 'src/app/services/via-cep.service';
import { TipoAtividadeModalComponent } from '../../modals/tipo-atividade-modal/tipo-atividade-modal.component';
import { CRMTipoAtividade } from 'src/app/models/crm/crmtipo-atividade';
import { ViaCep } from 'src/app/models/viacep';
import swal from 'sweetalert2';
import { CRMEtapaFunil } from 'src/app/models/crm/crmetapa-funil';
import { AlterarStatusOportunidadeComponent } from '../alterar-status-oportunidade/alterar-status-oportunidade.component';
import { Cliente } from 'src/app/models/cliente';
import { LogOportunidadeComponent } from '../log-oportunidade/log-oportunidade.component';
import { OportunidadeAnexoComponent } from '../../oportunidade-anexo/oportunidade-anexo.component';
import { UcComponent } from '../../uc/uc.component';
import { CRMHierarquiaUsuarioService } from 'src/app/services/crmhierarquia-usuario.service';
import { CRM } from 'src/app/models/crm/crmfunil';
import { EstatisticasModalComponent } from '../../modals/estatisticas-modal/estatisticas-modal.component';
import { Contato } from 'src/app/models/contato';

declare const $: any;

@Component({
  selector: 'app-editar-oportunidade',
  templateUrl: './editar-oportunidade.component.html',
  styleUrls: ['./editar-oportunidade.component.scss']
})
export class EditarOportunidadeComponent implements OnInit {
  // variáveis
  idCRMOportunidade = '';
  oportunidade = new CRMOportunidade();
  editando = false;
  carregando = true;
  public MASKS = MASKS;
  editavel = true;
  padrao = false;
  buscouOportunidade = false;
  classeStatus = 'text-info';

  statusAtual = undefined;
  respostaAtual = undefined;

  oportunidadeEdicao = new CRMOportunidade();
  contatoEdicao = new CRMContato();

  clienteEdicao = new Cliente();

  canaisDeVenda: CRMCanalVenda[] = [];
  usuarios: CRMHierarquiaUsuario[] = [];

  editarContato = false;
  editarOportunidade = false;

  estaNaHierarquia = false;

  ganharSomenteComVenda = false;

  estados = [
    'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI',
    'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'];
  estadoSelecionado = undefined;
  cidades: Ibge[] = [];
  cidadeSelcionado = undefined;

  trabalhaComAssinatura = false;

  somenteDonoVeValor = false;
  idUsuarioAtual = 0;
  administrador = false;

  confirmarMudancaEtapa = false;

  tags: CRMTag[] = [];
  tagsDaOportunidade = [];
  tagsDaOportunidadeEdicao = [];
  AtributoMascaras = CRMAtributoMascara;

  public atualizouSubject: BehaviorSubject<any>;

  podeEditarContato = false;
  podePerguntarParaTransferirAtividade = false;
  atributosDaOportunidadeEdicao: CRMOportunidadeAtributo[];

  crm = new CRM();

  fidelidadeGoSolar = false;

  private franquiaSubscription$: Subscription;

  constructor(
    private route: ActivatedRoute,
    private notificacaoService: NotificacaoService,
    private ibgeService: IbgeService,
    private oportunidadeService: CrmoportunidadeService,
    private funilService: CrmService,
    private platformLocation: PlatformLocation,
    private router: Router,
    private canalDeVendaService: CrmcanalVendaService,
    private hierarquiaService: CRMHierarquiaUsuarioService,
    private globalService: GlobalService,
    private carregandoService: CarregandoService,
    private contatoService: CrmcontatoService,
    private utilitarioService: UtilitarioService,
    public dialog: MatDialog,
    private viaCepService: ViaCepService,
    private tagService: CrmtagService,
    private tipoAtividadeService: CrmtipoAtividadeService,
    private empresaService: PremissasService,
    private crmService: CrmService,
    private premissasService: PremissasService
  ) {
    this.atualizouSubject = new BehaviorSubject<any>(undefined);
  }

  async ngOnInit() {
    // inscreve no evento de troca de franquia
    // this.franquiaSubscription$ = this.globalService.alterouFranquia.subscribe(franquia => {
    //   this.podeEditarContato = !this.globalService.trabalhaComFranquia() || (franquia && franquia.nomeFantasia !== 'Todos');
    // });

    this.idUsuarioAtual = Number((await this.globalService.consultaUsuario()).id);
    this.administrador = await this.globalService.administrador();

    // verifica configuração da empresa
    this.carregandoService.mostra('buscaConfEmpresa');
    this.empresaService.crmVisualizarValor().subscribe(resp => {
      this.carregandoService.esconde('buscaConfEmpresa');

      this.somenteDonoVeValor = resp.valor;

    }, (erro) => {
      this.carregandoService.esconde('buscaConfEmpresa');
      this.notificacaoService.erro(erro);
    });

    // verifica confirmação de mudança de etapa
    this.carregandoService.mostra('confirmarMudancaEtapa');
    this.empresaService.confirmarMudancaEtapa().subscribe(resp => {
      this.carregandoService.esconde('confirmarMudancaEtapa');

      this.confirmarMudancaEtapa = resp.valor;

    }, (erro) => {
      this.carregandoService.esconde('confirmarMudancaEtapa');
      this.notificacaoService.erro(erro);
    });

    // verifica se pode perguntar para transferir atividade
    this.carregandoService.mostra('pergAlterarAtividade');
    this.empresaService.pergAlterarAtividade().subscribe(resp => {
      this.carregandoService.esconde('pergAlterarAtividade');

      this.podePerguntarParaTransferirAtividade = resp.valor;

    }, (erro) => {
      this.carregandoService.esconde('pergAlterarAtividade');
      this.notificacaoService.erro(erro);
    });

    // this.trabalhaComAssinatura = this.globalService.trabalhaComAssinatura();

    this.route.params.subscribe(params => {
      if (params['id'] !== null && params['id'] !== undefined) {
        this.idCRMOportunidade = params['id'];
        this.verificaExistenciaNaHierarquia();
      } else {
        this.router.navigate(['/crm/oportunidades']);
      }
    });
  }

  buscarCrm(idCrm) {
    this.carregandoService.mostra('buscaCRM');
    this.crmService.consultarPorIdCRM(idCrm).subscribe(data => {
      this.crm = data;
      this.crm.textoGanho = this.crm.textoGanho === '' ? 'Ganhar' : this.crm.textoGanho;
      this.crm.textoPerda = this.crm.textoPerda === '' ? 'Perder' : this.crm.textoPerda;
      this.carregandoService.esconde('buscaCRM');
    }, (erro) => {
      this.carregandoService.esconde('buscaCRM');
      this.notificacaoService.erro('Não foi possível buscar dados deste CRM');
    });
  }

  buscarGanharSomenteComVenda() {
    this.carregandoService.mostra('buscarGanharSomenteComVenda');
    this.funilService.consultarPorIdCRM(this.oportunidade.idCRM).subscribe(c => {
      this.ganharSomenteComVenda = c.ganharOpVenda;
      this.carregandoService.esconde('buscarGanharSomenteComVenda');
    }, (erro) => {
      this.carregandoService.esconde('buscarGanharSomenteComVenda');
      this.notificacaoService.erro(erro);
    });
  }

  verificarSePodeEditar() {
    // verifica se pode editar
    this.carregandoService.mostra('podeEditar');
    this.oportunidadeService.podeEditar(this.idCRMOportunidade).subscribe(resposta => {
      this.carregandoService.esconde('podeEditar');

      this.editavel = resposta.valor;

    }, (erro) => {
      this.carregandoService.esconde('podeEditar');
      this.notificacaoService.erro(erro);
    });
  }

  buscarTags() {
    this.carregandoService.mostra('buscarTags');

    this.tagService.consultarTags().subscribe(
      (tags) => {
        this.tags = tags.map(t => t.statusCadastro === StatusCadastroEnum.Ativo ? t : { ...t, disabled: true });
        this.buscarFVOportunidade();

        this.carregandoService.esconde('buscarTags');
      },
      (erro) => {
        this.carregandoService.esconde('buscarTags');
        this.notificacaoService.erro(erro);
      }
    );
  }

  verificaExistenciaNaHierarquia() {
    this.carregandoService.mostra('verificaHierarquia');

    this.hierarquiaService.usuarioDentroDaHierarquia().subscribe(resp => {
      this.carregandoService.esconde('verificaHierarquia');
      this.carregando = false;

      if (!resp) {
        swal({
          title: 'Atenção!!!',
          text: 'Você não é membro de nenhum time!!!',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-warning',
          type: 'warning'
        }).then(() => {
          this.router.navigate(['/crm/oportunidades']);
        });
      } else {
        this.estaNaHierarquia = true;
        this.buscarCanaisDeVenda();

        // se for edição, busca o oportunidade do id passado
        if (this.idCRMOportunidade) {
          this.editando = true;
          this.buscarTags();
        } else {
          this.router.navigate(['/crm/oportunidades']);
        }
      }
    }, (erro) => {
      this.carregandoService.esconde('verificaHierarquia');
      this.notificacaoService.erro(erro);
    });
  }

  ngAfterViewInit(): void {
    this.utilitarioService.rodaScriptTabEnter();
  }

  buscarFVOportunidade() {
    this.carregandoService.mostra('buscaFVOportunidade');

    this.oportunidadeService.consultarPorIdOportunidade(this.idCRMOportunidade).subscribe(resp => {
      this.oportunidade = resp;

      this.statusAtual = this.oportunidade.status;
      this.respostaAtual = this.oportunidade.idResposta;

      if (this.oportunidade.tags && this.oportunidade.tags !== null && this.oportunidade.tags.length > 0) {
        this.tagsDaOportunidade = this.oportunidade.tags.map(p => p.id);
      } else {
        this.tagsDaOportunidade = [];
      }

      this.oportunidadeEdicao = Object.assign({}, this.oportunidade);
      this.tagsDaOportunidadeEdicao = this.tagsDaOportunidade;
      this.atributosDaOportunidadeEdicao = this.oportunidade.atributos.map(atributo => {
        return Object.assign({}, atributo);
      });

      this.clienteEdicao = Object.assign({}, this.oportunidade.cliente);
      this.contatoEdicao = Object.assign({}, this.oportunidade.contato);

      this.verificarSePodeEditar();
      this.buscarGanharSomenteComVenda();
      this.atualizaDadosFVOportunidade();
      this.buscarCrm(this.oportunidade.idCRM);
    }, (erro) => {
      this.carregandoService.esconde('buscaFVOportunidade');
      this.notificacaoService.erro(erro);
    });
  }

  buscarCanaisDeVenda() {
    this.carregandoService.mostra('buscaCanaisDeVenda');

    this.canalDeVendaService.consultarCanaisVenda().subscribe(resp => {
      this.canaisDeVenda = resp.map(c => c.statusCadastro === StatusCadastroEnum.Ativo ? c : { ...c, disabled: true });
      this.carregandoService.esconde('buscaCanaisDeVenda');
    }, (erro) => {
      this.carregandoService.esconde('buscaCanaisDeVenda');
      this.notificacaoService.erro(erro);
    });
  }

  buscarUsuarios() {
    this.carregandoService.mostra('buscaUsuarios');

    this.hierarquiaService.consultarHierarquiaDoUsuarioLista(this.oportunidade.idUsuario).subscribe(resp => {
      this.usuarios = resp;
      this.carregandoService.esconde('buscaUsuarios');
    }, (erro) => {
      this.carregandoService.esconde('buscaUsuarios');
      this.notificacaoService.erro(erro);
    });
  }

  atualizaDadosFVOportunidade() {
    this.buscarUsuarios();

    this.estadoSelecionado = this.estados.find(s => s === this.clienteEdicao.uf);
    this.buscouOportunidade = true;
    this.carregando = false;

    this.buscarCidades();

    this.carregandoService.esconde('buscaFVOportunidade');
  }

  salvar(interno?) {
    this.tagsDaOportunidade = this.tagsDaOportunidadeEdicao;
    this.oportunidadeEdicao.atributos = this.atributosDaOportunidadeEdicao.map(atributo => {
      return Object.assign({}, atributo);
    });

    if (!interno) {
      if (this.podePerguntarParaTransferirAtividade && this.oportunidade.idUsuario !== this.oportunidadeEdicao.idUsuario) {
        swal({
          title: 'Atenção!!',
          text: 'Deseja transferir as atividades sem responsável para o novo dono do card?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-info',
          cancelButtonClass: 'btn btn-danger',
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
          buttonsStyling: false
        }).then((result) => {
          if (result.value) {
            this.oportunidadeEdicao.transferirAtividades = true;
            this.oportunidade = Object.assign({}, this.oportunidadeEdicao);
          } else {
            this.oportunidadeEdicao.transferirAtividades = false;
            this.oportunidade = Object.assign({}, this.oportunidadeEdicao);
          }

          this.salvarOportunidade();
        });
      } else {
        this.oportunidadeEdicao.transferirAtividades = false;
        this.oportunidade = Object.assign({}, this.oportunidadeEdicao);
        this.salvarOportunidade();
      }
    } else {
      this.oportunidade.transferirAtividades = false;
      this.salvarOportunidade();
    }
  }

  salvarOportunidade() {
    this.carregandoService.mostra('salvaFVOportunidade');

    if (this.tagsDaOportunidade && this.tagsDaOportunidade !== null && this.tagsDaOportunidade.length > 0) {
      this.oportunidade.tags = this.tags.filter(p => this.tagsDaOportunidade.some(t => t === p.id));
    } else {
      this.oportunidade.tags = [];
    }

    this.oportunidade.dtStatus = new Date();

    const oportunidadeParaSalvar = Object.assign({}, this.oportunidade);
    try {
      oportunidadeParaSalvar.valorEstimado = Number(oportunidadeParaSalvar.valorEstimado);

      if (oportunidadeParaSalvar.potencia !== undefined && oportunidadeParaSalvar.potencia !== null) {
        oportunidadeParaSalvar.potencia = Number(oportunidadeParaSalvar.potencia);
      }
      if (oportunidadeParaSalvar.consumo !== undefined && oportunidadeParaSalvar.consumo !== null) {
        oportunidadeParaSalvar.consumo = Number(oportunidadeParaSalvar.consumo);
      }

      // É necessário converter o valor dos atributos para string
      oportunidadeParaSalvar.atributos.forEach(atributo => {
        if (atributo.valor) {
          if (atributo.mascara === CRMAtributoMascara.MaskNumber) {
            atributo.valor = this.utilitarioService.formataNumeroParaSalvar(atributo.valor.toString());
          } else if (atributo.mascara === CRMAtributoMascara.MaskDate) {
            const atributoData = new Date(atributo.valor);
            atributo.valor = atributoData.toISOString();
          }
        }
      });

      this.oportunidadeService.salvar(oportunidadeParaSalvar).subscribe((novoId) => {
        this.notificacaoService.sucesso('Card salvo com sucesso!!!');
        this.carregandoService.esconde('salvaFVOportunidade');
        this.editarOportunidade = false;
        this.atualizouSubject.next(true);

      }, (erro) => {
        this.carregandoService.esconde('salvaFVOportunidade');
        this.notificacaoService.erro(erro);
      });
    } catch (erro) {
      this.carregandoService.esconde('salvaFVOportunidade');
      this.notificacaoService.erro(erro);
    }
  }

  alterarStatus() {
    this.carregandoService.mostra('salvaFVOportunidade');

    const dataAtual = this.oportunidade.dtStatus;

    this.oportunidade.dtStatus = new Date();

    const oportunidadeParaSalvar = Object.assign({}, this.oportunidade);
    oportunidadeParaSalvar.valorEstimado = Number(oportunidadeParaSalvar.valorEstimado);

    if (oportunidadeParaSalvar.potencia !== undefined && oportunidadeParaSalvar.potencia !== null) {
      oportunidadeParaSalvar.potencia = Number(oportunidadeParaSalvar.potencia);
    }
    if (oportunidadeParaSalvar.consumo !== undefined && oportunidadeParaSalvar.consumo !== null) {
      oportunidadeParaSalvar.consumo = Number(oportunidadeParaSalvar.consumo);
    }

    this.oportunidadeService.alterarStatus(oportunidadeParaSalvar).subscribe((resp) => {
      this.statusAtual = this.oportunidade.status;
      this.respostaAtual = this.oportunidade.idResposta;

      this.notificacaoService.sucesso('Card salvo com sucesso!!!');
      this.carregandoService.esconde('salvaFVOportunidade');
      this.editarOportunidade = false;

      this.buscarFVOportunidade();

      this.atualizouSubject.next(true);
    }, (erro) => {
      this.oportunidade.status = this.statusAtual;
      this.oportunidade.idResposta = this.respostaAtual;
      this.oportunidade.dtStatus = dataAtual;
      this.carregandoService.esconde('salvaFVOportunidade');
      this.notificacaoService.erro(erro);
    });
  }

  alterarEtapa() {
    this.carregandoService.mostra('salvaFVOportunidade');

    this.oportunidade.dtStatus = new Date();

    const oportunidadeParaSalvar = Object.assign({}, this.oportunidade);

    oportunidadeParaSalvar.valorEstimado = Number(oportunidadeParaSalvar.valorEstimado);

    if (oportunidadeParaSalvar.potencia !== undefined && oportunidadeParaSalvar.potencia !== null) {
      oportunidadeParaSalvar.potencia = Number(oportunidadeParaSalvar.potencia);
    }
    if (oportunidadeParaSalvar.consumo !== undefined && oportunidadeParaSalvar.consumo !== null) {
      oportunidadeParaSalvar.consumo = Number(oportunidadeParaSalvar.consumo);
    }

    this.oportunidadeService.alterarEtapa(oportunidadeParaSalvar).subscribe((novoId) => {
      this.notificacaoService.sucesso('Card salvo com sucesso!!!');
      this.carregandoService.esconde('salvaFVOportunidade');
      this.editarOportunidade = false;
      this.buscarFVOportunidade();
      this.atualizouSubject.next(true);

    }, (erro) => {
      this.carregandoService.esconde('salvaFVOportunidade');
      this.notificacaoService.erro(erro);
    });
  }

  validaSalvar() {
    return this.oportunidade.idEtapa;
  }

  salvarCliente(interno?) {

  }

  salvarContato(interno?) {
    this.carregandoService.mostra('salvaFVContato');

    if (!interno) {
      this.contatoEdicao.uf = this.estadoSelecionado;
      this.contatoEdicao.ibge = this.cidadeSelcionado;
      this.contatoEdicao.cidade = this.cidades.find(s => s.cod === this.contatoEdicao.ibge) ?
        this.cidades.find(s => s.cod === this.contatoEdicao.ibge).cidade : '';
      this.oportunidade.contato = Object.assign({}, this.contatoEdicao);
    }

    this.contatoService.salvar(this.oportunidade.contato).subscribe((resp) => {
      this.notificacaoService.sucesso('Cliente salvo com sucesso!!!');

      this.carregandoService.esconde('salvaFVContato');
      this.editarContato = false;
    }, (erro) => {
      this.carregandoService.esconde('salvaFVContato');
      this.notificacaoService.erro(erro);
    });
  }

  buscarCidades(nomeCidade?: string) {
    this.carregandoService.mostra('buscaCidades');
    this.ibgeService.consultarPorEstado(this.estadoSelecionado).subscribe((ibges: Ibge[]) => {
      this.cidades = ibges;

      if (nomeCidade) {
        this.cidadeSelcionado = this.cidades.find(s => this.utilitarioService.remover_acentos_espaco(s.cidade.toLowerCase().trim()) === this.utilitarioService.remover_acentos_espaco(nomeCidade.toLowerCase().trim())) ?
          this.cidades.find(s => this.utilitarioService.remover_acentos_espaco(s.cidade.toLowerCase().trim()) === this.utilitarioService.remover_acentos_espaco(nomeCidade.toLowerCase().trim())).cod : undefined;
      } else {
        this.cidadeSelcionado = this.cidades.find(s => s.cod === this.clienteEdicao.ibge) ?
          this.cidades.find(s => s.cod === this.clienteEdicao.ibge).cod : undefined;
      }
      this.carregandoService.esconde('buscaCidades');
    }, (erro) => {
      this.carregandoService.esconde('buscaCidades');
    });
  }

  validaSalvarContato() {
    return this.contatoEdicao.fone1 || this.contatoEdicao.email;
  }

  buscarDuracao() {
    const duracao = this.utilitarioService.retornaDiferencaDeDias(
      this.oportunidade.status === 0 ? new Date() : new Date(this.oportunidade.dtStatus), new Date(this.oportunidade.dtAbertura));
    return duracao + (duracao === 1 ? ' dia' : ' dias');
  }

  buscarStatus() {
    switch (this.oportunidade.status) {
      case 0:
        this.classeStatus = 'text-info';
        return 'Aberta';

      case 1:
        this.classeStatus = 'text-danger';
        return this.crm.textoPerda;

      case 2:
        this.classeStatus = 'text-success';
        return this.crm.textoGanho;

      case 3:
        this.classeStatus = 'text-gelo';
        return 'Congelada';

      case 4:
        this.classeStatus = 'text-danger';
        return 'Excluída';

      default:
        break;
    }
  }

  expectativaVencida() {
    return this.utilitarioService.retornaDiferencaDeDias(new Date(this.oportunidade.dtExpectativa), this.oportunidade.status === 0 ? new Date() : new Date(this.oportunidade.dtStatus)) < 0;
  }

  pesquisarContato() {
    // const dialogRef = this.dialog.open(ClientesModalsComponent, {
    //   width: ($('body').width()).toString() + 'px',
    //   data: {},
    //   panelClass: 'modal-card'
    // });

    // dialogRef.afterClosed().subscribe((result: Cliente) => {
    //   if (result) {
    //     this.carregandoService.mostra('buscarContato');

    //     this.contatoService.consultarPorIdContato(result.id).subscribe(
    //       (contato) => {
    //         this.oportunidade.contato = contato;
    //         this.oportunidade.idContato = contato.id;
    //         this.contatoEdicao = Object.assign({}, this.oportunidade.contato);
    //         this.salvar(true);
    //         this.carregandoService.esconde('buscarContato');
    //       },
    //       (erro) => {
    //         this.carregandoService.esconde('buscarContato');
    //         this.notificacaoService.erro(erro);
    //       }
    //     );
    //   }
    // });
  }

  ganharOportunidade() {
    swal({
      title: 'Atenção!!',
      html: `Você selecionou a ação <b>${this.crm.textoGanho}</b>. </br> Tem certeza de que deseja prosseguir com esta ação?`,
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.oportunidade.status = 2;

        this.alterarStatus();

        this.router.navigate(['/crm/oportunidades']).then(() => {
        });
      }
    });
  }

  perderOportunidade() {
    // const dialogRef = this.dialog.open(AlterarStatusOportunidadeComponent, {
    //   data: {
    //     tipoResposta: 0
    //   },
    //   panelClass: 'modal-card'
    // });

    // dialogRef.afterClosed().subscribe((resp) => {
    //   if (resp) {
        swal({
          title: 'Atenção!!',
          html: `Você selecionou a ação <b>${this.crm.textoPerda}</b>. </br> Tem certeza de que deseja prosseguir com esta ação?`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-info',
          cancelButtonClass: 'btn btn-danger',
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
          buttonsStyling: false
        }).then((result) => {
          if (result.value) {
            this.oportunidade.status = 1;
            // this.oportunidade.idResposta = Number(resp);
            this.alterarStatus();

            this.router.navigate(['/crm/oportunidades']).then(() => {
            });
          }
        });
    //   }
    // });
  }

  congelarOportunidade() {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente Congelar a Oportunidade?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.oportunidade.status = 3;
        this.oportunidade.idResposta = null;

        this.alterarStatus();
      }
    });
  }

  excluirOportunidade() {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente Excluir a Oportunidade?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.oportunidade.status = 4;
        this.oportunidade.idResposta = null;

        this.alterarStatus();
      }
    });
  }

  reabrirOportunidade() {
    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente Reabrir a Oportunidade?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.oportunidade.status = 0;
        this.oportunidade.idResposta = null;

        this.alterarStatus();
      }
    });
  }

  ngOnDestroy(): void { }

  selecionaEtapa(etapa: CRMEtapaFunil) {
    if (!this.editavel) {
      return;
    }

    if (this.confirmarMudancaEtapa) {
      swal({
        title: 'Atenção!!',
        text: 'Deseja realmente alterar a etapa do card?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-info',
        cancelButtonClass: 'btn btn-danger',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        buttonsStyling: false
      }).then((result) => {
        if (result.value) {
          this.oportunidade.idEtapa = etapa.id;

          this.alterarEtapa();
        }
      });
    } else {
      this.oportunidade.idEtapa = etapa.id;
      this.alterarEtapa();
    }
  }

  habilitarDesabilitarEdicaoOportunidade() {
    this.editarOportunidade = !this.editarOportunidade;

    this.oportunidadeEdicao = Object.assign({}, this.oportunidade);
    this.tagsDaOportunidadeEdicao = this.tagsDaOportunidade;
    this.atributosDaOportunidadeEdicao = this.oportunidade.atributos.map(atributo => {
      return Object.assign({}, atributo);
    });
  }

  habilitarDesabilitarEdicaoContato() {
    this.editarContato = !this.editarContato;

    this.contatoEdicao = Object.assign({}, this.oportunidade.contato);
  }

  abrirLogDaOportunidade() {
    const dialogRef = this.dialog.open(LogOportunidadeComponent, {
      width: ($('body').width()).toString() + 'px',
      data: { idOportunidade: this.idCRMOportunidade, oportunidade: this.oportunidade },
      panelClass: 'modal-card'
    });
  }

  buscarEnderecoPorCep() {
    this.carregandoService.mostra('buscaEnderecoPorCep');
    this.viaCepService.obterEndereco(this.clienteEdicao.cep).subscribe((viaCep: ViaCep) => {

      this.clienteEdicao.bairro = viaCep.bairro;
      this.clienteEdicao.rua = viaCep.logradouro;
      this.estadoSelecionado = viaCep.uf;
      this.clienteEdicao.ibge = viaCep.ibge;

      this.buscarCidades();
      $('#numero').focus();

      this.carregandoService.esconde('buscaEnderecoPorCep');
    }, (erro) => {
      this.carregandoService.esconde('buscaEnderecoPorCep');
      this.notificacaoService.erro('Não foi possível acessar o serviço de CEP!');
    });
  }

  criarOrcamento() {
    this.carregandoService.mostra('buscaTiposAtividade');
    this.tipoAtividadeService.consultarTiposAtividade().subscribe((tipos: CRMTipoAtividade[]) => {

      const tiposComOrcamento = tipos.filter(p => p.vincularOrcamento);

      if (tiposComOrcamento.length === 0) {
        this.notificacaoService.erro('Nenhum tipo de atividade com vínculo de orçamento encontrado!!!');
      } else if (tiposComOrcamento.length > 1) {
        const dialogRef = this.dialog.open(TipoAtividadeModalComponent, {
          // width: ($('body').width()).toString() + 'px',
          data: {
            orcamento: true
          },
          panelClass: 'modal-card'
        });

        dialogRef.afterClosed().subscribe((resp) => {
          if (resp) {
            this.router.navigate(['/orcamentos/novo'],
              { state: { idOportunidade: this.idCRMOportunidade, idVendedor: this.oportunidade.idUsuario, idTipoAtividade: resp, idCliente: this.oportunidade.idContato, consumo: Number(this.oportunidade.consumo) } });
          }
        });
      } else {
        this.router.navigate(['/orcamentos/novo'],
          { state: { idOportunidade: this.idCRMOportunidade, idVendedor: this.oportunidade.idUsuario, idTipoAtividade: tiposComOrcamento[0].id, idCliente: this.oportunidade.idContato, consumo: Number(this.oportunidade.consumo) } });
      }

      this.carregandoService.esconde('buscaTiposAtividade');
    }, (erro) => {
      this.carregandoService.esconde('buscaTiposAtividade');
      this.notificacaoService.erro(erro);
    });
  }

  enviarEmailParaContato() {
    // const dialogRef = this.dialog.open(TemplateEmailModalComponent, {
    //   data: {},
    //   panelClass: 'modal-card'
    // });

    // dialogRef.afterClosed().subscribe((resp) => {
    //   if (resp) {
    //     this.carregandoService.mostra('enviarEmailParaContato');
    //     this.oportunidadeService.enviarEmailParaContato(this.idCRMOportunidade, resp).subscribe(resposta => {
    //       this.notificacaoService.sucesso('Email enviado com sucesso!!!');

    //       this.carregandoService.esconde('enviarEmailParaContato');
    //     }, (erro) => {
    //       this.carregandoService.esconde('enviarEmailParaContato');
    //       this.notificacaoService.erro(erro);
    //     });
    //   }
    // });
  }

  anexos() {
    const dialogRef = this.dialog.open(OportunidadeAnexoComponent, {
      width: ($('body').width()).toString() + 'px',
      data: {
        idOportunidade: this.oportunidade.id
      },
      panelClass: 'modal-card'
    });
  }

  unidadesRecebedoras() {
    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(UcComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: {
        idOportunidade: this.oportunidade.id
      },
      panelClass: 'modal-card'
    });
  }

  editarCliente() {
    const url = this.router.createUrlTree(['crm/clientes/editar', this.oportunidade.contato.id]);

    window.open(location.origin + this.platformLocation.getBaseHrefFromDOM() + url.toString(), '_blank');
  }

  conversarPeloWhatsapp() {
    let celular = this.oportunidade.contato.fone1 ? this.oportunidade.contato.fone1.replace('(', '').replace(')', '').replace(' ', '').replace('-', '') : '';

    if (!celular || celular.length !== 11) {
      this.notificacaoService.erroMSG('Cliente sem celular cadastrado ou com celular inválido!!!');
    } else {
      let texto = '';
      let link = 'https://wa.me/55' + celular + '?text=' + encodeURIComponent(texto);
      window.open(link, '_blank');
    }
  }

  preencherAssinatura() {
    // this.carregandoService.mostra('buscarPorIdCliente');

    // this.assinaturaService.buscarPorIdCliente(this.oportunidade.idContato).subscribe((resp) => {

    //   this.carregandoService.esconde('buscarPorIdCliente');

    //   resp.idCliente = this.oportunidade.idContato;
    //   resp.donoOportunidade = Number(this.oportunidade.idUsuario);

    //   const url = this.router.createUrlTree(['/']);

    //   const dialogRef = this.dialog.open(AssinaturaModalComponent, {
    //     width: ($('body').width()).toString() + 'px',
    //     data: {
    //       assinatura: resp,
    //       url: location.origin + this.platformLocation.getBaseHrefFromDOM() + url.toString()
    //     },
    //     panelClass: 'modal-card'
    //   });

    // }, (erro) => {
    //   this.carregandoService.esconde('buscarPorIdCliente');
    //   this.notificacaoService.erro(erro);
    // });
  }

  assinar() {
    this.router.navigate(['/assinatura'],
      { state: { idCliente: this.oportunidade.idContato } });
  }

  verEstatisticasCliente() {
    const dialogRef = this.dialog.open(EstatisticasModalComponent, {
      width: ($('body').width()).toString() + 'px',
      data: { idCliente: this.clienteEdicao.id },
      panelClass: 'modal-card'
    });
  }
}
